import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import userService from '../../services/user';

const initialState = {
  loading: false,
  clients: [],
  error: '',
  params: {
    page: 1,
    perPage: 10,
  },
  meta: {},
};

function normalizeListMeta(payload) {
  const pag = payload?.pagination ?? {};
  const meta = payload?.meta ?? {};
  return {
    current_page: pag.page ?? meta.current_page ?? 1,
    per_page: pag.perPage ?? meta.per_page ?? 10,
    total: pag.total ?? meta.total ?? 0,
    last_page: pag.lastPage ?? meta.last_page,
  };
}

export const fetchClients = createAsyncThunk(
  'user/fetchClients',
  (params = {}) => {
    const { role: _r, status: _s, ...rest } = {
      ...initialState.params,
      ...params,
    };
    return userService.listCustomers(rest).then((res) => res);
  }
);

const clientSlice = createSlice({
  name: 'client',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchClients.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchClients.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      const rows = payload?.data;
      state.clients = Array.isArray(rows) ? rows : [];
      const m = normalizeListMeta(payload);
      state.meta = {
        current_page: m.current_page,
        per_page: m.per_page,
        total: m.total,
        last_page: m.last_page,
      };
      state.params.page = m.current_page;
      state.params.perPage = m.per_page;
      state.error = '';
    });
    builder.addCase(fetchClients.rejected, (state, action) => {
      state.loading = false;
      state.clients = [];
      state.error = action.error.message;
    });
  },
});

export default clientSlice.reducer;
